import React, { Component } from 'react';

import { SectionTitle, SectionDescription, BoxContentIcon }  from '../../helpers/section';
import { isMobile } from 'react-device-detect';
import { Link } from 'react-router-dom';

const desc = "Fundada em 1998 por especialistas em rádio com muitos anos de experiência em " +
"telecomunicações e na indústria de rádio de micro-ondas, a 4RF é, hoje, uma empresa global, " +
"com clientes em mais de 140 países, de vários setores.";  

class PageInternalFourRF extends Component {
    render() {
        return (
            <section className={ isMobile ? 'page-internal-mobile' : 'page-internal'} id="page" >
                <div className="container">
                    {SectionTitle({section: '4RF', subtitle:'CONHEÇA A', featured: '4RF'})}
                    {SectionDescription(desc)}   
                    <div className="mt-50">&nbsp;</div>   
                    {SectionTitle({section: 'Produtos', subtitle:'PRINCIPAIS', featured: 'PRODUTOS E APLICAÇÕES'})}
                    
                    <h4>Rádios ponto a ponto e ponto a multiponto</h4>
                    <div className="row">
                        <div className="col-12 col-md-4">
                            <img src={process.env.PUBLIC_URL + '/assets/images/Products-Aprisa-SR-Family.jpg'} alt="Products-Aprisa-SR-Family" className="logo-internal" className="img-fluid" /> 
                        </div>
                        <div className="col-12 col-md-8">
                            <h5>Destaque: APRISA SR</h5>  
                            <p className="align-left">Controle e monitoramento de infraestrutura de missão crítica.</p>      
                            <ul>
                                <li>Rádios em frequências VHF e UHF e, agora, em 900 MHz não licenciada;</li>
                                <li>Rádios ponto a multiponto de banda estreita, inteligentes e seguras para aplicações SCADA e de telemetria;</li>
                                <li>Alta performance, disponibilidade, confiabilidade e robustez.</li>
                            </ul>                            
                        </div>
                        <div className="col-12">
                            <hr/>
                        </div>                        
                    </div>
                    
                    <h4>Rádios ponto a ponto sem visada</h4>
                    <div className="row">
                        <div className="col-12 col-md-4">
                            <img src={process.env.PUBLIC_URL + '/assets/images/Products-Aprisa-XE.jpg'} alt="Products-Aprisa-XE" className="logo-internal" className="img-fluid" /> 
                        </div>
                        <div className="col-12 col-md-8">
                            <h5>Destaque: APRISA XE</h5>  
                            <ul>
                                <li>Enlaces para longas distâncias em mais de 130 países;</li>
                                <li>Homologados na Anatel nas faixas de frequências de 300 MHz, 400 MHz, 1.4 GHz e 2.2 GHz;</li>
                                <li>Enlaces ponto a ponto de longo alcance. É flexível e possui interfaces legadas como E1, FXS, FXO, E&amp;M e seriais;</li>                                
                                <li>Elevado desempenho com capacidade de até 65 Mbps;</li>
                                <li>O Aprisa XE proporciona um excelente desempenho, máxima disponibilidade, capacidade e confiabilidade em caminhos de longa distância nas condições mais difíceis, como topografia caótica, obstruções, passagens de água, temperatura e extremos atmosféricos que não são limites para o Aprisa XE.</li>                                
                            </ul>                            
                        </div>
                        <div className="col-12">
                            <hr/>
                        </div>                        
                    </div>

                </div>
            </section>
        )
    }
}

export default PageInternalFourRF;
